import styled from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
	BaseContent,
	BaseItem,
	MenuSeparator,
	MenuPortal,
	MenuShortcut,
	MenuTrigger,
	Checkmark as MenuCheckmark,
} from '../Menu/style';
import { zIndex } from '../../../tokens';

interface ItemProps {
	disabled?: boolean;
	$isMobile?: boolean;
}

interface ShortcutProps {
	$isMobile?: boolean;
}

interface ContentProps {
	$isMobile?: boolean;
}

export const Item = styled(DropdownMenu.Item)<ItemProps>`
	${BaseItem}
`;

export const Shortcut = styled(MenuShortcut)<ShortcutProps>``;

export const Checkmark = styled(MenuCheckmark)<{ $isMobile?: boolean }>``;

export const Separator = styled(DropdownMenu.Separator)`
	${MenuSeparator}
`;

export const Trigger = styled(DropdownMenu.Trigger)`
	${MenuTrigger}
`;

export const Root = styled(DropdownMenu.Root)``;

export const Portal = styled(DropdownMenu.Portal)`
	${MenuPortal}
`;

export const Content = styled(DropdownMenu.Content)<ContentProps>`
	${BaseContent}
	z-index: ${zIndex.contextMenu};
`;
